export default "__VITE_ASSET__058bc851__"